import {
  SET_MATERIALITY_ASSESSMENT_LIST,
  SET_MATERIALITY_ASSESSMENT_DETAILS,
  SET_ORIGINAL_MATERIALITY_ASSESSMENT_DETAILS,
  SET_MATERIALITY_MAIN_TOPIC,
  SET_MATERIALITY_TOPIC,
  SET_SELECTED_MATERIALITY_TOPIC,
  SET_TOPIC_LIMIT,
  SET_MATERIALITY_ASSESSMENT_YEAR_LIST,
  SET_MATERIALITY_ASSIGNED_USERS,
  SET_MATERIALITY_TOPIC_ANALYSIS,
  SET_SURVEY_RESPONSES,
} from "constants/materialityAssessment/matAssessmentConst";

const initial_state = {
  materialityAssessmentList: [],
  materialityAssessmentDetails: {},
  originalMaterialityAssessmentDetails: {},
  totalMaterialityAssessments: null,
  materialityMainTopics: [],
  materialityTopics: [],
  selectedMaterialityTopics: {},
  topicCount: null,
  topicLimit: 10,
  materialityAssessmentYearList: [],
  materialityAssiegnedUsers: [],
  materialityTopicAnalysis: [],
  surveyResponses:[]
};

export default function reducer(state = initial_state, action) {
  switch (action.type) {
    case "RESET_STATE":
      return (state = {
        ...state,
        ...initial_state,
      });
    case SET_MATERIALITY_ASSESSMENT_LIST:
      return (state = {
        ...state,
        materialityAssessmentList: action.payload?.result,
        totalMaterialityAssessments: action.payload?.total,
      });

    case SET_MATERIALITY_ASSESSMENT_DETAILS:
      return (state = {
        ...state,
        materialityAssessmentDetails: action.payload,
      });
    case SET_ORIGINAL_MATERIALITY_ASSESSMENT_DETAILS:
      return (state = {
        ...state,
        originalMaterialityAssessmentDetails: action.payload,
      });

    case SET_MATERIALITY_MAIN_TOPIC:
      return (state = {
        ...state,
        materialityMainTopics: action.payload,
      });

    case SET_MATERIALITY_TOPIC:
      return (state = {
        ...state,
        materialityTopics: action.payload.result,
        topicCount: action.payload.total,
      });

    case SET_SELECTED_MATERIALITY_TOPIC:
      return (state = {
        ...state,
        selectedMaterialityTopics: action.payload,
      });

    case SET_TOPIC_LIMIT:
      return (state = {
        ...state,
        topicLimit: action.payload,
      });

    case SET_MATERIALITY_ASSESSMENT_YEAR_LIST:
      return (state = {
        ...state,
        materialityAssessmentYearList: action.payload,
      });

    case SET_MATERIALITY_ASSIGNED_USERS:
      return (state = {
        ...state,
        materialityAssiegnedUsers: action.payload,
      });

    case SET_MATERIALITY_TOPIC_ANALYSIS:
      return (state = {
        ...state,
        materialityTopicAnalysis: action.payload,
      });
      case SET_SURVEY_RESPONSES:
      return (state = {
        ...state,
        surveyResponses: action.payload,
      });
    default:
      return state;
  }
}
